import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { routeGuardFn } from '../../../../components/src/lib/shared/services/route-guard.service';
import { ziroFormConfirmRouteChangeGuardFn } from '../../../../components/src/lib/forms/ziro-form-confirm-route-change.service';
import { MigrationsComponent } from '../../../../components/src/lib/migrations/migrations.component';
import { MigrationsTableComponent } from '../../../../components/src/lib/migrations/migrations-table/migrations-table.component';
import { MigrationsCreateComponent } from '../../../../components/src/lib/migrations/migrations-create/migrations-create.component';
import { MigrationsCiscoComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco.component';
import { MigrationsCiscoDashboardComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-dashboard/migrations-cisco-dashboard.component';
import { MigrationsCiscoDirectoryNumbersReportComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-directory-number-report/migrations-cisco-directory-numbers-report.component';
import { MigrationsCiscoHuntListsReportComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-hunt-list-report/migrations-cisco-hunt-lists-report.component';
import { MigrationsCiscoHuntListsReportLineGroupsComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-hunt-list-report/migrations-hunt-list-report-line-groups/migrations-cisco-hunt-lists-report-line-groups.component';
import { MigrationsAutoAttendantsDetailedViewComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-auto-attendant-report/migrations-auto-attendants-detailed-view/migrations-auto-attendants-detailed-view.component';
import { MigrationsAutoAttendantsComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-auto-attendant-report/migrations-auto-attendants.component';
import { MigrationsRingCentralComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/migrations-ring-central.component';
import { MigrationsRingCentralNumbersReportComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/migrations-ring-central-numbers-report/migrations-ring-central-numbers-report.component';
import { RingCentralCallQueuesListViewComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/ring-central-call-queues/ring-central-call-queues-list-view/ring-central-call-queues-list-view.component';
import { RingCentralCallQueueComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/ring-central-call-queues/ring-central-call-queue/ring-central-call-queue.component';
import { MigrationsRingCentralDashboardComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/migrations-ring-central-dashboard/migrations-ring-central-dashboard.component';
import { RingCentralAutoAttendantsListComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/ring-central-auto-attendants/ring-central-auto-attendants-list.component';
import { RingCentralAutoAttendantsDetailedViewComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/ring-central-auto-attendants/ring-central-auto-attendants-detailed-view/ring-central-auto-attendants-detailed-view.component';
import { MigrationsCiscoSiteManagementComponent } from 'projects/components/src/lib/migrations/site-migration/migrations-cisco-site-management/migrations-cisco-site-management.component';

const migrationsRouteConfig: Routes = [
  {
    path: 'tenants/:tenantId',
    component: MigrationsComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;migrations.title',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: MigrationsTableComponent,
      },
      {
        path: 'new',
        component: MigrationsCreateComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
      },
      {
        path: 'cisco',
        data: { pbxType: 'cisco' },
        children: [
          {
            path: ':id',
            component: MigrationsCiscoComponent,
            canActivate: [routeGuardFn],
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MigrationsCiscoDashboardComponent,
              },
              {
                path: 'site-configuration',
                component: MigrationsCiscoSiteManagementComponent,
                canActivate: [routeGuardFn],
                canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
              },
              {
                path: 'cucm-directory-numbers-report',
                component: MigrationsCiscoDirectoryNumbersReportComponent,
              },
              {
                path: 'cucm-directory-numbers-report/:filter',
                component: MigrationsCiscoDirectoryNumbersReportComponent,
              },
              {
                path: 'cucm-hunt-lists-report',
                component: MigrationsCiscoHuntListsReportComponent,
              },
              {
                path: 'cucm-hunt-lists-report/:name',
                component: MigrationsCiscoHuntListsReportLineGroupsComponent,
              },
              {
                path: 'cuc-auto-attendants-report/call-handler',
                component: MigrationsAutoAttendantsDetailedViewComponent,
              },
              {
                path: 'cuc-auto-attendants-report',
                component: MigrationsAutoAttendantsComponent,
              },
              {
                path: 'cuc-auto-attendants-report/:filter',
                pathMatch: 'full',
                component: MigrationsAutoAttendantsComponent,
              },
            ],
          },
        ],
      },
      {
        path: 'ring-central',
        data: { pbxType: 'ring-central' },
        children: [
          {
            path: ':id',
            component: MigrationsRingCentralComponent,
            canActivate: [routeGuardFn],
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MigrationsRingCentralDashboardComponent,
              },
              {
                path: 'numbers-report',
                component: MigrationsRingCentralNumbersReportComponent,
              },
              {
                path: 'numbers-report/:filter',
                component: MigrationsRingCentralNumbersReportComponent,
              },
              {
                path: 'call-queues',
                component: RingCentralCallQueuesListViewComponent,
              },
              {
                path: 'call-queues/:callQueueId',
                component: RingCentralCallQueueComponent,
              },
              {
                path: 'ring-central-auto-attendants-report',
                component: RingCentralAutoAttendantsListComponent,
              },
              {
                path: 'ring-central-auto-attendants-report/:autoAttendantId',
                component: RingCentralAutoAttendantsDetailedViewComponent,
              },
            ],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(migrationsRouteConfig)],
  exports: [RouterModule],
})
export class MigrationsRoutingModule {}
